import React, { Component } from 'react';
import FileStackImage from 'misc/filestack_image';

class CoverImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
    this.ratio = props.height / props.width;
    this.image = new FileStackImage({
      ...props.image,
      transform: {
        resize: {
          fit: 'crop',
          align: 'center',
          width: props.width * 2,
          height: props.height * 2,
        },
      },
    });
  }

  static defaultProps = {
    width: 400,
    height: 300,
    className: '',
  };

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(prevProps, prevState) {
    const handleChanged = prevProps.image.handle !== this.props.image.handle;
    const policyChanged = prevProps.image.policy !== this.props.image.policy;
    /**
     * We reload the image in one of two cases:
     *
     *  A) When the handle change:
     *
     *     This means we're using an entirely new image!
     *
     * B) Or when the policy change AND we failed to load the previous image:
     *
     *    If the policy alone has changed but the handel hasn't, that means
     *    we're using the same image but with a new policy. Reloading the image
     *    on policy change alone can be unnecessary sometimes if the previous
     *    image loaded successfully using the old policy. To avoid unnecessary
     *    requests, we only need to re-request the image, if the previous image
     *    failed to load. That's why `policyChanged` is paired with
     *    `prevState.error`.
     */
    if (handleChanged || (policyChanged && prevState.error)) {
      this.image.updateParams(this.props.image);
      this.loadImage();
    }
  }

  loadImage() {
    const image = new Image();
    image.src = this.image.url;
    image.onloadstart = () => this.setState({ error: null });
    image.onload = () => this.setState({ error: null });
    image.onerror = () => this.setState({ error: true });
  }

  render() {
    const { loading } = this.state;
    return (
      <div
        className={`LearnCardImageCover-imageContainer ${this.props.className}`}
      >
        <div
          className="LearnCardImageCover-image"
          style={{
            backgroundImage: loading ? undefined : `url(${this.image.url})`,
            paddingBottom: `${this.ratio * 100}%`,
          }}
        />
      </div>
    );
  }
}

export default CoverImage;
